/* eslint-disable import/no-extraneous-dependencies */
// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"vf4uxZOR2ZkQ-Ge1k2Uhs"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from '@sentry/nextjs';

const initSentry = () => {
  Sentry.init({
    dsn: 'https://be5e6ff1a0794d679a70357278328bb3@o894200.ingest.sentry.io/5860519',
    // Adjust this value in production, or use tracesSampler for greater control
    tracesSampler(samplingContext) {
      // disable pageload transaction
      if (samplingContext.transactionContext.op === 'pageload') {
        return 0.005;
      }

      return 0.1;
    },
    sampleRate: 0.1,
    ignoreErrors: [
      /Cannot read property 'im_guest_enable' of undefined/i,
      /Incorrect password/i,
    ],
    enabled: process.env.NEXT_PUBLIC_STAGE === 'prod',

    // ...
    // Note: if you want to override the automatic release value, do not set a
    // `release` value here - use the environment variable `SENTRY_RELEASE`, so
    // that it will also get attached to your source maps
  });
};

// 延迟初始化Sentry
if (typeof window !== 'undefined') {
  // 在DOMContentLoaded之后初始化
  if (
    document.readyState === 'complete' ||
    document.readyState === 'interactive'
  ) {
    // DOM已经准备好，用setTimeout确保在主线程空闲时初始化
    setTimeout(initSentry, 0);
  } else {
    // 等待DOM加载完成
    window.addEventListener('DOMContentLoaded', () => {
      setTimeout(initSentry, 0);
    });
  }
}
